import * as types from './personal-notes.types';
import * as constants from './personal-notes.constants';
import { IPersonalNote, IPersonalNoteUpdate } from '../../../resource/personal-note/personal-note.types';

export const setupPersonalNotes = (): types.ISetupPersonalNotes => ({
  type: constants.SETUP_PERSONAL_NOTES,
});

export const createPersonalNote = (): types.ICreatePersonalNote => ({
  type: constants.CREATE_PERSONAL_NOTE,
});

export const updatePersonalNote = (
  noteId: IPersonalNote['id'],
  note: IPersonalNoteUpdate,
): types.IUpdatePersonalNote => ({
  type: constants.UPDATE_PERSONAL_NOTE,
  payload: {
    id: noteId,
    data: note,
  },
});

export const deletePersonalNote = (noteId: IPersonalNote['id']): types.IDeletePersonalNote => ({
  type: constants.DELETE_PERSONAL_NOTE,
  payload: noteId,
});

export const storePersonalNotes = (noteIds: IPersonalNote['id'][]): types.IStorePersonalNotes => ({
  type: constants.STORE_PERSONAL_NOTES,
  payload: noteIds,
});

export const clearPersonalNotes = (): types.IClearPersonalNotes => ({
  type: constants.CLEAR_PERSONAL_NOTES,
});
